import { PartialBrief } from '../../../../Types/Brief'

// return string includes leading space
export const formatLayout = ({ layouts }: PartialBrief): string | undefined => {
  if (!layouts || layouts === 'not_sure') return undefined
  if (layouts === 'seating') return ' (seated)'

  return ` (${layouts.replace(/_+/g, ' ').toLocaleLowerCase()})`
}
